import React, { ReactElement } from 'react';
import {
  Col, Heading, Row, Button,
} from 'idsk-react-components';
import { useActionContext } from '../../context/ConfirmActionContext';
import './confirmAction.scss';

interface Props {
  doAfterCancel?: () => void;
}

const ConfirmAction = ({ doAfterCancel }:Props): ReactElement => {
  const {
    visible, cancelAction, confirmAction, confirmationText, confirmActionType,
  } = useActionContext();

  const onCancel = ():void => {
    cancelAction();
    if (doAfterCancel) {
      doAfterCancel();
    }
  };
  return (
    <div id="confirm-action-wrapper">
      { visible && (
        <div className={`confirm-action-wrapper ${confirmActionType}`}>
          <Row>
            <Col>
              <Heading className="heading" size="s">{confirmationText}</Heading>
              <Button
                buttonStyle="action"
                onClick={confirmAction}
                size="large"
              >Áno
              </Button>
              <button
                type="button"
                className="cancel-action"
                onClick={onCancel}
              >Nie
              </button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default ConfirmAction;
